var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03971 3.97933V5.646C6.0588 5.64603 5.09956 5.9346 4.28143 6.47576C3.46331 7.01692 2.82243 7.78678 2.43859 8.68947C2.05475 9.59217 1.94492 10.5878 2.12276 11.5525C2.30059 12.5171 2.75825 13.4082 3.43875 14.1147C4.11924 14.8212 4.99251 15.3119 5.94983 15.5257C6.90715 15.7396 7.90622 15.6671 8.82267 15.3174C9.73911 14.9676 10.5324 14.356 11.1039 13.5588C11.6753 12.7615 11.9996 11.8137 12.0364 10.8335L12.0397 10.646H13.7064C13.7064 12.4141 13.004 14.1098 11.7538 15.36C10.5035 16.6103 8.80782 17.3127 7.03971 17.3127C5.2716 17.3127 3.57591 16.6103 2.32567 15.36C1.07543 14.1098 0.373047 12.4141 0.373047 10.646C0.373047 7.0335 3.35638 3.97933 7.03971 3.97933ZM15.373 0.645996V2.31266L10.9339 7.31266H15.373V8.97933H8.70638V7.31266L13.1447 2.31266H8.70638V0.645996H15.373Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestTime);
export default __webpack_public_path__ + "static/media/rest-time.151a2947e0d582425cffc1d2b896a756.svg";
export { ForwardRef as ReactComponent };